import { Tooltip } from "@mui/material";

interface ProgressBarMultiProps {
  total: number;
  delivered: number;
  partial: number;
  returned: number;
  width?: number;
  height?: number;
  showCounter?: boolean;
}

export default function ProgressBarMulti({
  total,
  delivered,
  partial,
  returned,
  width = 100,
  height = 8,
  showCounter = true
}: ProgressBarMultiProps) {
  if (total === 0) return null;

  const pending = total - delivered - partial - returned;
  const completed = delivered + partial + returned;
  const deliveredPercent = (delivered / total) * 100;
  const partialPercent = (partial / total) * 100;
  const returnedPercent = (returned / total) * 100;

  const tooltipContent = (
    <div style={{ fontSize: '12px', lineHeight: '1.5' }}>
      <div style={{ color: '#666' }}>Pendientes: {pending}</div>
      <div style={{ color: '#4caf50' }}>Entregados: {delivered}</div>
      <div style={{ color: '#ff9800' }}>Parciales: {partial}</div>
      <div style={{ color: '#f44336' }}>Devueltos: {returned}</div>
    </div>
  );

  return (
    <Tooltip 
      title={tooltipContent} 
      arrow 
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'white',
            color: '#333',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            '& .MuiTooltip-arrow': {
              color: 'white',
            },
          },
        },
      }}
    >
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        marginTop: '4px',
        cursor: 'pointer'
      }}>
        <div style={{ 
          width: `${width}px`, 
          height: `${height}px`, 
          backgroundColor: '#e0e0e0', 
          borderRadius: `${height / 2}px`,
          overflow: 'hidden',
          display: 'flex'
        }}>
          {/* Entregados - Verde */}
          {delivered > 0 && (
            <div style={{ 
              width: `${deliveredPercent}%`,
              height: '100%',
              backgroundColor: '#4caf50',
              transition: 'width 0.3s ease'
            }} />
          )}
          {/* Parciales - Naranja */}
          {partial > 0 && (
            <div style={{ 
              width: `${partialPercent}%`,
              height: '100%',
              backgroundColor: '#ff9800',
              transition: 'width 0.3s ease'
            }} />
          )}
          {/* Devueltos - Rojo */}
          {returned > 0 && (
            <div style={{ 
              width: `${returnedPercent}%`,
              height: '100%',
              backgroundColor: '#f44336',
              transition: 'width 0.3s ease'
            }} />
          )}
        </div>
        {showCounter && (
          <span style={{ 
            fontSize: '11px', 
            color: '#666',
            whiteSpace: 'nowrap'
          }}>
            {completed}/{total}
          </span>
        )}
      </div>
    </Tooltip>
  );
}
